module.exports = __webpack_public_path__ + "preset.ced0e1fea22e1bb1e0c6571947551c9d.png";